<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
</script>

<div class="fixed inset-0 z-20 flex flex-col items-center justify-center overflow-y-auto bg-[#000000cc] backdrop-blur-md transition-opacity">
  <div class="w-[400px]">
    <div class="w-full rounded-t-md bg-darkgray p-5">
      <div class="pb-3 text-center text-lg font-bold tracking-wide text-[#A7A7A7]">Do you want to continue with existing data or start again..?</div>
    </div>
  </div>
  <div class="flex w-[400px] justify-between rounded-b-md bg-[#242424] px-5 py-3">
    <button on:click class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none">
      <span class="text-white group-hover:text-white group-active:text-white">
        <i class="fa-solid fa-play-pause" />
      </span>
      <span class="select-none group-hover:text-white">&nbsp;&nbsp;Resume</span>
    </button>
    <button
      on:click={() => {
        dispatch("startAgain")
      }}
      class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 focus:outline-none"
    >
      <span class="text-white group-hover:text-white group-active:text-white">
        <i class="fa-solid fa-circle-play" />
      </span>
      <span class="select-none group-hover:text-white">&nbsp;&nbsp;Start Again</span>
    </button>
  </div>
</div>
